import React from 'react';
import { universalCarePlanOptions } from './commons';

interface UniversalCarePlanSectionProps {
  hasUniversalCarePlan: string;
  updateEndOfLifeCare: (field: 'hasUniversalCarePlan', value: string) => void;
}

const UniversalCarePlanSection: React.FC<UniversalCarePlanSectionProps> = ({
  hasUniversalCarePlan,
  updateEndOfLifeCare,
}) => {
  return (
    <div className="mt-10 govuk-bp:mt-14">
      <h2 className="govuk-heading-l">Universal Care Plan</h2>

      <div className="govuk-form-group">
        <label className="govuk-label" htmlFor="universal-care-plan">
          Does the person have a Universal Care Plan? Please leave this blank if
          UCPs are not used in your region.
        </label>

        <select
          className="govuk-select govuk-!-width-one-half"
          id="universal-care-plan"
          name="hasUniversalCarePlan"
          value={hasUniversalCarePlan}
          onChange={e =>
            updateEndOfLifeCare('hasUniversalCarePlan', e.target.value)
          }
        >
          {universalCarePlanOptions.map(option => (
            <option key={option.value || 'select'} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default UniversalCarePlanSection;
